import { useLocation } from 'react-router';

export function useNonAmpUrl() {
  const location = useLocation();
  return location.pathname.replace('/amp/', '/').replace(/#.+$/, '');
}
